
<ng-container *ngTemplateOutlet="showAsDialog ? dialog : content"></ng-container>

<ng-template #dialog>
    <agpr-dialog-container
        [id]="'mfaSetupDialog'"
        [heading]="heading"
        class="agpr-mfaSetupDialog"
        (close)="closeDialog()"
    >
        <agpr-scroll-panel class="agpr-mfaSetupDialog-scrollPanel">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </agpr-scroll-panel>
        <ng-template #footerLeft>
            <ng-container *ngTemplateOutlet="leftButton"></ng-container>
        </ng-template>
        <ng-template #footerRight>
            <ng-container *ngTemplateOutlet="rightButton"></ng-container>
        </ng-template>
    </agpr-dialog-container>
  </ng-template>

<ng-template #content>
    <div class="agpr-mfaSetup-container">
        <ng-container *ngIf="!goToConfirm">
            <h1 class="agpr-headerH1-darkSmaller" *ngIf="!showAsDialog"> {{ heading }} </h1>
            <p
                class="agpr-mfaSetup-label"
                *ngIf="showSetupRequiredMessage"
            >  {{ 'Mfa.setup.requiredMessage' | localize }}
            </p>
            <ul
                role="radiogroup"
                [attr.aria-label]="'Mfa.setup.availableMethods' | localize"
            >
                <label class="agpr-mfaSetup-label">  {{ 'Mfa.setup.availableMethods' | localize }} </label>
                <li *ngFor="let method of allowedMfaSetupMethods; index as i">
                    <agpr-radio
                        [id]="'mfaSetup_mfaMethod_' + i"
                        [label]="'Mfa.' + method.type"
                        [value]="method"
                        [(ngModel)]="selectedMfaMethod"
                    ></agpr-radio>
                    <agpr-email-text-input
                        class="agpr-mfaSetup-email"
                        *ngIf="method.type === mfaTypes.email && selectedMfaMethod.type === mfaTypes.email"
                        [label]="'Mfa.' + mfaTypes.email"
                        [placeholder]="'Mfa.' + mfaTypes.email + '.placeholder'"
                        [required]="true"
                        [id]="'mfaSetup_mfMethod_emailInput'"
                        [(ngModel)]="selectedMfaMethod.email"
                    ></agpr-email-text-input>
                    <div
                        *ngIf="method.type === mfaTypes.mobileApp && selectedMfaMethod.type === mfaTypes.mobileApp"
                        class="agpr-mfaSetup-mobileApp"
                    >
                        <agpr-text-input
                            [id]="'mfaSetup_mfMethod_mobileAppInput'"
                            [required]="true"
                            [label]="'Mfa.management.identifier'"
                            placeholder="Mfa.management.identifier.placeholder"
                            [(ngModel)]="selectedMfaMethod.name"
                        ></agpr-text-input>
                        <agpr-message [severity]="messageSeverityEnum.info">
                          <p [innerHTML]="('Mfa.setup.mobileApp.info' | localize) | sanitizeHtml"></p>
                        </agpr-message>
                        <label class="agpr-mfaSetup-label"> {{ 'Mfa.setup.mobileApp.qrCodeMessage' | localize }} </label>
                        <div class="qrcodeImage">
                            <qrcode
                                [qrdata]="'otpauth://totp/Agility%20PR%20Solutions:?secret='+ selectedMfaMethod.seed + '&issuer=Agility%20PR%20Solutions'"
                                [allowEmptyString]="true"
                                [cssClass]="'center'"
                                [colorDark]="'#000000ff'"
                                [colorLight]="'#ffffffff'"
                                [elementType]="'img'"
                                [errorCorrectionLevel]="'M'"
                                [margin]="4"
                                [scale]="1"
                                [width]="300"
                            ></qrcode>
                            <span> {{ selectedMfaMethod.seed }} </span>
                        </div>

                    </div>
                </li>
            </ul>
        </ng-container>
        <ng-container *ngIf="goToConfirm">
            <h1 class="agpr-headerH1-darkSmaller" *ngIf="!showAsDialog">  {{ heading }} </h1>
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ 'Mfa.confirm.message.' + selectedMfaMethod.type | localize: {name: selectedMfaMethod.type === mfaTypes.email ? selectedMfaMethod.email : selectedMfaMethod.name} }}
            </agpr-message>
            <agpr-text-input
                [id]="'mfaSetup_confirmationCode'"
                label="Confirmation Code"
                [required]="true"
                [maxLength]="6"
                [(ngModel)]="selectedMfaMethod.confirmationCode"
                ariaDescribedBy="mfaSetup_confirmationCode_error"
            ></agpr-text-input>
            <agpr-form-message id="mfaSetup_confirmationCode_error" *ngIf="isCodeInvalid">
                {{  'Mfa.confirm.error.invalidCode' | localize }}
            </agpr-form-message>
        </ng-container>
        <div class="agpr-mfaSetup-footer" *ngIf="!showAsDialog">
            <div class="agpr-mfaSetup-footer--left">
                <ng-container *ngTemplateOutlet="leftButton"></ng-container>
            </div>
            <div class="agpr-mfaSetup-footer--right">
                <ng-container *ngTemplateOutlet="rightButton"></ng-container>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #leftButton>
    <agpr-button
        id="mfaSetupDialog_cancel"
        [label]="cancelLabel"
        [style]="buttonTypes.secondary"
        (click)="cancel.emit()"
    ></agpr-button>
</ng-template>
<ng-template #rightButton>
    <agpr-button
        *ngIf="!goToConfirm"
        id="mfaSetupDialog_nextStep"
        label="Mfa.nextStep"
        [disabled]="(selectedMfaMethod.type === mfaTypes.email && !selectedMfaMethod.email)
                    || (selectedMfaMethod.type === mfaTypes.mobileApp && !selectedMfaMethod.name)"
        [style]="buttonTypes.primary"
        (click)="goToConfirmMfa()"
    ></agpr-button>
    <agpr-button
        *ngIf="goToConfirm && selectedMfaMethod.type === mfaTypes.email"
        id="mfaSetupDialog_resendCode"
        label="Mfa.resendCode"
        [style]="buttonTypes.secondary"
        (click)="goToConfirmMfa()"
    ></agpr-button>
    <agpr-button
        *ngIf="goToConfirm"
        id="mfaSetupDialog_confirm"
        label="Mfa.confirm"
        [style]="buttonTypes.primary"
        [disabled]="!selectedMfaMethod.confirmationCode"
        (click)="confirmMfa()"
    ></agpr-button>
</ng-template>

